"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackOrderStatusInfo = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackOrderStatusInfo(notification_message) {
    const eventData = {
        eventName: enums_1.GA4EventName.ShowNotification,
        feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
        notification_type: 'Order Overview Product Information',
        notification_message,
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventCategory: enums_1.EventCategory.CustomerAccount,
        eventAction: 'Order Overview Product Information',
        eventLabel: notification_message,
        eventValue: undefined,
        nonInteraction: false,
        eventData,
    });
}
exports.trackOrderStatusInfo = trackOrderStatusInfo;
//# sourceMappingURL=trackOrderStatusInfo.js.map